import React, { Suspense } from "react";
import { Grid, Card, CardHeader, CardContent } from "@mui/material";
import { ConfigurationList } from "../components/configuration";
import "../styles/deployment.css";
import ConfigurationStats from "../components/configuration/ConfigurationStats";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateConfigurationTile from "../components/configuration/CreateConfigurationTile";

const Configurations = () => {
    return (
        <div className="fragmentContainer">
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                <Suspense fallback={<StatSkeleton tiles={1} />}>
                    <ConfigurationStats />
                </Suspense>
                <CreateConfigurationTile />
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} >
                    <Card variant="outlined">
                        <CardHeader title="Custom Configuration List"></CardHeader>
                        <CardContent
                            sx={{
                                padding: 0,
                            }}
                        >
                            <ConfigurationList />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div >
    );
};

export default Configurations;
